/**
 * AssistenciasAbertasWidget — chamados de CLIENTES no pós-venda (ativos e
 * atrasados). Não confundir com as solicitações internas de assistência
 * (ASM/AST/ASP), que têm widgets próprios.
 */
import React from "react";
import { Link } from "react-router-dom";

import { listarAssistencias } from "../../../services/posvenda";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "assistencias_abertas",
  label: "Assistências ao cliente (pós-venda)",
  descricao: "Chamados de clientes ativos no pós-venda (e quantos estão atrasados no SLA).",
  categoria: "Pendencias",
  permissoes: ["assistencia:view"],
  tamanho_default: "S",
  essencial: false,
};

export async function fetchData(request) {
  const ativas = await listarAssistencias(request, { ativas: true, pageSize: 1 });
  const atrasadas = await listarAssistencias(request, { atrasadas: true, pageSize: 1 });
  const cAtivas = Array.isArray(ativas) ? ativas.length : (ativas?.count ?? (ativas?.results || []).length);
  const cAtras = Array.isArray(atrasadas) ? atrasadas.length : (atrasadas?.count ?? (atrasadas?.results || []).length);
  return { ativas: cAtivas, atrasadas: cAtras };
}

export function Widget({ dados }) {
  const ativas = dados?.ativas ?? 0;
  const atrasadas = dados?.atrasadas ?? 0;
  return (
    <>
      <CardBody>
        <KpiValor style={{ color: atrasadas > 0 ? "var(--danger-text)" : undefined }}>
          {ativas}
        </KpiValor>
        <KpiSub>
          {atrasadas > 0
            ? `${atrasadas} fora do SLA — acao urgente`
            : "Nenhuma atrasada"}
        </KpiSub>
      </CardBody>
      <CardFooter>
        {/* /rc/assistencias nunca existiu: o link caía no início. */}
        <LinkLight as={Link} to="/posvenda/assistencias">Ver chamados</LinkLight>
      </CardFooter>
    </>
  );
}
